import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ListRoutesSectorPage } from './list-routes-sector';
import {ComponentsModule} from "../../components/components.module";

@NgModule({
  declarations: [
    ListRoutesSectorPage,
  ],
  imports: [
    IonicPageModule.forChild(ListRoutesSectorPage),
    ComponentsModule
  ],
})
export class ListRoutesSectorPageModule {}



// WEBPACK FOOTER //
// ./src/pages/list-routes-sector/list-routes-sector.module.ts